<template>
  <div class="spinner-grow spinner-grow-sm spinner-bg" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow spinner-grow-sm spinner-bg" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow spinner-grow-sm spinner-bg" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
